import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getHeaderTags = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/header-tags';
    const pathInternal = '/api/header-tags';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.integrationType : (params.integrationType ?? queryDefaults?.['integrationType']);
        if (value !== undefined) {
            urlParams.append('integrationType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prebidVersion : (params.prebidVersion ?? queryDefaults?.['prebidVersion']);
        if (value !== undefined) {
            urlParams.append('prebidVersion', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTags.paramsOrder = [{ type: 'parameters' }];
export const createHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags';
    const pathInternal = '/api/header-tags';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createHeaderTag.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getHeaderTagByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagIds === undefined) {
        throw new Error('Missing required parameter: headerTagIds');
    }
    const path = '/api/ws-header-tag/header-tags/by-ids';
    const pathInternal = '/api/header-tags/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.headerTagIds !== undefined) {
        params.headerTagIds.forEach((item) => urlParams.append('headerTagIds', item.toString()));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagByIds.paramsOrder = [{ type: 'parameters' }];
export const getHeaderTagById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagById.paramsOrder = [{ type: 'parameters' }];
export const updateHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTag.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const exportHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/export'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/export'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exportHeaderTag.paramsOrder = [{ type: 'parameters' }];
export const importHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTag === undefined) {
        throw new Error('Missing required body: headerTag');
    }
    const path = '/api/ws-header-tag/header-tags/import';
    const pathInternal = '/api/header-tags/import';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.headerTag !== undefined) {
        body = params.headerTag;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
importHeaderTag.paramsOrder = [{ type: 'body', paramName: 'headerTag' }];
export const getBidderConfigsAsCsv = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/header-tags/bidder-configs/csv';
    const pathInternal = '/api/header-tags/bidder-configs/csv';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.headerTagName : (params.headerTagName ?? queryDefaults?.['headerTagName']);
        if (value !== undefined) {
            urlParams.append('headerTagName', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.bidder : (params.bidder ?? queryDefaults?.['bidder']);
        if (value !== undefined) {
            urlParams.append('bidder', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'text/csv';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getBidderConfigsAsCsv.paramsOrder = [{ type: 'parameters' }];
export const importBidderConfigsAsCsv = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.csvContent === undefined) {
        throw new Error('Missing required body: csvContent');
    }
    const path = '/api/ws-header-tag/header-tags/bidder-configs/csv';
    const pathInternal = '/api/header-tags/bidder-configs/csv';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.csvContent !== undefined) {
        body = params.csvContent;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'text/csv';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
importBidderConfigsAsCsv.paramsOrder = [{ type: 'body', paramName: 'csvContent' }];
export const getWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/header-tags/websites';
    const pathInternal = '/api/header-tags/websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getWebsites.paramsOrder = [{ type: 'parameters' }];
export const changeHeaderActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changeHeaderActiveState.paramsOrder = [{ type: 'parameters' }];
export const cloneHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.headerTagCloneForm === undefined) {
        throw new Error('Missing required body: headerTagCloneForm');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/clone'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/clone'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.headerTagCloneForm !== undefined) {
        body = params.headerTagCloneForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneHeaderTag.paramsOrder = [{ type: 'body', paramName: 'headerTagCloneForm' }, { type: 'parameters' }];
export const getDynamicPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDynamicPlacements.paramsOrder = [{ type: 'parameters' }];
export const createDynamicPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDynamicPlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Update dynamic placement */ export const updateDynamicPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.dynamicPlacementId === undefined) {
        throw new Error('Missing required parameter: dynamicPlacementId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDynamicPlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete dynamic placement */ export const deleteDynamicPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.dynamicPlacementId === undefined) {
        throw new Error('Missing required parameter: dynamicPlacementId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteDynamicPlacement.paramsOrder = [{ type: 'parameters' }];
/** Set dynamic placement active state */ export const setDynamicPlacementActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.dynamicPlacementId === undefined) {
        throw new Error('Missing required parameter: dynamicPlacementId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}/active/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements/{dynamicPlacementId}/active/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{dynamicPlacementId}', () => encodeURIComponent(String(params.dynamicPlacementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setDynamicPlacementActive.paramsOrder = [{ type: 'parameters' }];
export const updateDynamicPlacementsSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDynamicPlacementsSortOrder.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get raw scripts for AdTag */ export const getHeaderTagRawScripts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagRawScripts.paramsOrder = [{ type: 'parameters' }];
export const createHeaderTagRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createHeaderTagRawScript.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get raw scripts for AdTag */ export const getAssignableRawScripts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/assignable-raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/assignable-raw-scripts'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAssignableRawScripts.paramsOrder = [{ type: 'parameters' }];
export const updateHeaderTagRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.headerTagRawScriptId === undefined) {
        throw new Error('Missing required parameter: headerTagRawScriptId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTagRawScript.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteHeaderTagRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.headerTagRawScriptId === undefined) {
        throw new Error('Missing required parameter: headerTagRawScriptId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteHeaderTagRawScript.paramsOrder = [{ type: 'parameters' }];
/** Set header tag raw script active state */ export const setHeaderTagRawScriptActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.headerTagRawScriptId === undefined) {
        throw new Error('Missing required parameter: headerTagRawScriptId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}/active/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts/{headerTagRawScriptId}/active/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{headerTagRawScriptId}', () => encodeURIComponent(String(params.headerTagRawScriptId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setHeaderTagRawScriptActive.paramsOrder = [{ type: 'parameters' }];
export const updateHeaderTagRawScriptsSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/raw-scripts/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/raw-scripts/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTagRawScriptsSortOrder.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get floor rules */ export const getHeaderTagFloorRules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagFloorRules.paramsOrder = [{ type: 'parameters' }];
export const createOrUpdateHeaderTagFloorRules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateHeaderTagFloorRules.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteHeaderTagFloorRules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/floor-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteHeaderTagFloorRules.paramsOrder = [{ type: 'parameters' }];
/** Get disable rules for AdTag */ export const getDisableRules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/disable-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/disable-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDisableRules.paramsOrder = [{ type: 'parameters' }];
export const createDisableRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/disable-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/disable-rules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDisableRule.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateDisableRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.disableRuleId === undefined) {
        throw new Error('Missing required parameter: disableRuleId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/disable-rules/{disableRuleId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{disableRuleId}', () => encodeURIComponent(String(params.disableRuleId)));
    const pathInternal = '/api/header-tags/{headerTagId}/disable-rules/{disableRuleId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{disableRuleId}', () => encodeURIComponent(String(params.disableRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDisableRule.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteDisableRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.disableRuleId === undefined) {
        throw new Error('Missing required parameter: disableRuleId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/disable-rules/{disableRuleId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{disableRuleId}', () => encodeURIComponent(String(params.disableRuleId)));
    const pathInternal = '/api/header-tags/{headerTagId}/disable-rules/{disableRuleId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{disableRuleId}', () => encodeURIComponent(String(params.disableRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteDisableRule.paramsOrder = [{ type: 'parameters' }];
export const updateDisableRulesSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/disable-rules/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/disable-rules/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDisableRulesSortOrder.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacements.paramsOrder = [{ type: 'parameters' }];
export const createPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const importPlacementBidders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/import-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/import-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
importPlacementBidders.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const findBidderAliasesByPlacementIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementIds === undefined) {
        throw new Error('Missing required body: placementIds');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/bidder-aliases'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/bidder-aliases'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placementIds !== undefined) {
        body = params.placementIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findBidderAliasesByPlacementIds.paramsOrder = [
    { type: 'body', paramName: 'placementIds' },
    { type: 'parameters' },
];
export const removePlacementBidders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/remove-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/remove-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removePlacementBidders.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getPlacementStatistics = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placement-statistics'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placement-statistics'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementStatistics.paramsOrder = [{ type: 'parameters' }];
export const getPlacementById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementById.paramsOrder = [{ type: 'parameters' }];
export const updatePlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deletePlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deletePlacement.paramsOrder = [{ type: 'parameters' }];
export const changePlacementActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementActiveState.paramsOrder = [{ type: 'parameters' }];
export const updatePlacementsSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/update-sort-order'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePlacementsSortOrder.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const changePlacementBidderActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementBidderId === undefined) {
        throw new Error('Missing required parameter: placementBidderId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placement-bidders/{placementBidderId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementBidderId}', () => encodeURIComponent(String(params.placementBidderId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/placement-bidders/{placementBidderId}/change-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementBidderId}', () => encodeURIComponent(String(params.placementBidderId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementBidderActiveState.paramsOrder = [{ type: 'parameters' }];
export const changePlacementBidderIntegrationType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementBidderId === undefined) {
        throw new Error('Missing required parameter: placementBidderId');
    }
    if (params.integrationType === undefined) {
        throw new Error('Missing required parameter: integrationType');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placement-bidders/{placementBidderId}/change-integration-type/{integrationType}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementBidderId}', () => encodeURIComponent(String(params.placementBidderId)))
        .replaceAll('{integrationType}', () => encodeURIComponent(String(params.integrationType)));
    const pathInternal = '/api/header-tags/{headerTagId}/placement-bidders/{placementBidderId}/change-integration-type/{integrationType}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementBidderId}', () => encodeURIComponent(String(params.placementBidderId)))
        .replaceAll('{integrationType}', () => encodeURIComponent(String(params.integrationType)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementBidderIntegrationType.paramsOrder = [{ type: 'parameters' }];
export const changePlacementGoogleBidderActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}/change-google-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}/change-google-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementGoogleBidderActiveState.paramsOrder = [{ type: 'parameters' }];
export const changePlacementAdSenseBidderActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}/change-ad-sense-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}/change-ad-sense-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementAdSenseBidderActiveState.paramsOrder = [{ type: 'parameters' }];
export const changePlacementAmazonBidderActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}/change-amazon-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}/change-amazon-bidder-active-state/{active}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePlacementAmazonBidderActiveState.paramsOrder = [{ type: 'parameters' }];
/** Returns paginated history logs for placements and related entities */ export const getPlacementHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/{placementId}/history'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/{placementId}/history'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementHistory.paramsOrder = [{ type: 'parameters' }];
/** Returns the distinct values available for filtering placement change history, either of a single placement or of all placements of the header tag */ export const getPlacementHistoryFilterOptions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/placements/history/filter-options'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/placements/history/filter-options'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.placementId : (params.placementId ?? queryDefaults?.['placementId']);
        if (value !== undefined) {
            urlParams.append('placementId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementHistoryFilterOptions.paramsOrder = [{ type: 'parameters' }];
/** Returns paginated change history for a header tag, grouped into history entries and filtered by the given criteria */ export const queryHeaderTagHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/history/query'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/history/query'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
queryHeaderTagHistory.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns the distinct values available for filtering a header tag's change history */ export const getHeaderTagHistoryFilterOptions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/history/filter-options'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/history/filter-options'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagHistoryFilterOptions.paramsOrder = [{ type: 'parameters' }];
/** Returns paginated history logs for dynamic placements */ export const getDynamicPlacementHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/dynamic-placements/history'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/dynamic-placements/history'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDynamicPlacementHistory.paramsOrder = [{ type: 'parameters' }];
/** Returns paginated history logs for floor rules and related entries */ export const getFloorRuleHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorRuleId === undefined) {
        throw new Error('Missing required parameter: floorRuleId');
    }
    const path = '/api/ws-header-tag/floor-rules/{floorRuleId}/history'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    const pathInternal = '/api/floor-rules/{floorRuleId}/history'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFloorRuleHistory.paramsOrder = [{ type: 'parameters' }];
/** Get paginated notes for a header tag */ export const getHeaderTagNotes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/notes'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/notes'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagNotes.paramsOrder = [{ type: 'parameters' }];
/** Create a note for a header tag */ export const createHeaderTagNote = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/notes'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/notes'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createHeaderTagNote.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Update a note (only the creator can update) */ export const updateHeaderTagNote = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.noteId === undefined) {
        throw new Error('Missing required parameter: noteId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/notes/{noteId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{noteId}', () => encodeURIComponent(String(params.noteId)));
    const pathInternal = '/api/header-tags/{headerTagId}/notes/{noteId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{noteId}', () => encodeURIComponent(String(params.noteId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTagNote.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete a note (only the creator can delete) */ export const deleteHeaderTagNote = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.noteId === undefined) {
        throw new Error('Missing required parameter: noteId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/notes/{noteId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{noteId}', () => encodeURIComponent(String(params.noteId)));
    const pathInternal = '/api/header-tags/{headerTagId}/notes/{noteId}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{noteId}', () => encodeURIComponent(String(params.noteId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteHeaderTagNote.paramsOrder = [{ type: 'parameters' }];
export const getPrebidClientBidders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/prebid-client-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/prebid-client-bidders'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPrebidClientBidders.paramsOrder = [{ type: 'parameters' }];
export const getPrebidModules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/prebid-modules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/prebid-modules'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPrebidModules.paramsOrder = [{ type: 'parameters' }];
export const getPrebidClientHeaderTag = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/prebid-client'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/prebid-client'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPrebidClientHeaderTag.paramsOrder = [{ type: 'parameters' }];
export const getPrebidServerPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.minWidth === undefined) {
        throw new Error('Missing required parameter: minWidth');
    }
    const path = '/api/ws-header-tag/header-tags/prebid-server/placements/{placementId}-{minWidth}'
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{minWidth}', () => encodeURIComponent(String(params.minWidth)));
    const pathInternal = '/api/header-tags/prebid-server/placements/{placementId}-{minWidth}'
        .replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)))
        .replaceAll('{minWidth}', () => encodeURIComponent(String(params.minWidth)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPrebidServerPlacement.paramsOrder = [{ type: 'parameters' }];
export const getScriptUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    const path = '/api/ws-header-tag/header-tags/{headerTagId}/script-url'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/header-tags/{headerTagId}/script-url'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getScriptUrl.paramsOrder = [{ type: 'parameters' }];
export const getCompanyRawScripts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/raw-scripts';
    const pathInternal = '/api/raw-scripts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyRawScripts.paramsOrder = [{ type: 'parameters' }];
export const createCompanyRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/raw-scripts';
    const pathInternal = '/api/raw-scripts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyRawScript.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const updateCompanyRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.rawScriptId === undefined) {
        throw new Error('Missing required parameter: rawScriptId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/raw-scripts/{rawScriptId}'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    const pathInternal = '/api/raw-scripts/{rawScriptId}'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyRawScript.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteCompanyRawScript = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.rawScriptId === undefined) {
        throw new Error('Missing required parameter: rawScriptId');
    }
    const path = '/api/ws-header-tag/raw-scripts/{rawScriptId}'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    const pathInternal = '/api/raw-scripts/{rawScriptId}'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCompanyRawScript.paramsOrder = [{ type: 'parameters' }];
/** Set company raw script active state */ export const setCompanyRawScriptActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.rawScriptId === undefined) {
        throw new Error('Missing required parameter: rawScriptId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-header-tag/raw-scripts/{rawScriptId}/active/{active}'
        .replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/raw-scripts/{rawScriptId}/active/{active}'
        .replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setCompanyRawScriptActive.paramsOrder = [{ type: 'parameters' }];
export const getHeaderTagsAssignedToCompanyRawScripts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.rawScriptId === undefined) {
        throw new Error('Missing required parameter: rawScriptId');
    }
    const path = '/api/ws-header-tag/raw-scripts/{rawScriptId}/header-tags'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    const pathInternal = '/api/raw-scripts/{rawScriptId}/header-tags'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagsAssignedToCompanyRawScripts.paramsOrder = [{ type: 'parameters' }];
export const updateHeaderTagsAssignedToCompanyRawScripts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.rawScriptId === undefined) {
        throw new Error('Missing required parameter: rawScriptId');
    }
    if (params.headerTagIds === undefined) {
        throw new Error('Missing required body: headerTagIds');
    }
    const path = '/api/ws-header-tag/raw-scripts/{rawScriptId}/header-tags'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    const pathInternal = '/api/raw-scripts/{rawScriptId}/header-tags'.replaceAll('{rawScriptId}', () => encodeURIComponent(String(params.rawScriptId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.headerTagIds !== undefined) {
        body = params.headerTagIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTagsAssignedToCompanyRawScripts.paramsOrder = [
    { type: 'body', paramName: 'headerTagIds' },
    { type: 'parameters' },
];
export const getCompanyFloorRules = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/floor-rules';
    const pathInternal = '/api/floor-rules';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyFloorRules.paramsOrder = [{ type: 'parameters' }];
export const createCompanyFloorRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/floor-rules';
    const pathInternal = '/api/floor-rules';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyFloorRule.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const updateCompanyFloorRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorRuleId === undefined) {
        throw new Error('Missing required parameter: floorRuleId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/floor-rules/{floorRuleId}'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    const pathInternal = '/api/floor-rules/{floorRuleId}'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyFloorRule.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteCompanyFloorRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorRuleId === undefined) {
        throw new Error('Missing required parameter: floorRuleId');
    }
    const path = '/api/ws-header-tag/floor-rules/{floorRuleId}'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    const pathInternal = '/api/floor-rules/{floorRuleId}'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCompanyFloorRule.paramsOrder = [{ type: 'parameters' }];
export const getHeaderTagsAssignedToCompanyFloorRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorRuleId === undefined) {
        throw new Error('Missing required parameter: floorRuleId');
    }
    const path = '/api/ws-header-tag/floor-rules/{floorRuleId}/header-tags'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    const pathInternal = '/api/floor-rules/{floorRuleId}/header-tags'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHeaderTagsAssignedToCompanyFloorRule.paramsOrder = [{ type: 'parameters' }];
export const updateHeaderTagsAssignedToCompanyFloorRule = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorRuleId === undefined) {
        throw new Error('Missing required parameter: floorRuleId');
    }
    if (params.headerTagIds === undefined) {
        throw new Error('Missing required body: headerTagIds');
    }
    const path = '/api/ws-header-tag/floor-rules/{floorRuleId}/header-tags'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    const pathInternal = '/api/floor-rules/{floorRuleId}/header-tags'.replaceAll('{floorRuleId}', () => encodeURIComponent(String(params.floorRuleId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.headerTagIds !== undefined) {
        body = params.headerTagIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateHeaderTagsAssignedToCompanyFloorRule.paramsOrder = [
    { type: 'body', paramName: 'headerTagIds' },
    { type: 'parameters' },
];
export const getBidders = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/bidders';
    const pathInternal = '/api/bidders';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBidders.paramsOrder = [];
export const getAllJsonSchemas = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/bidders/json-schemas';
    const pathInternal = '/api/bidders/json-schemas';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllJsonSchemas.paramsOrder = [];
export const getJsonSchema = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.bidder === undefined) {
        throw new Error('Missing required parameter: bidder');
    }
    const path = '/api/ws-header-tag/bidders/json-schemas/{bidder}'.replaceAll('{bidder}', () => encodeURIComponent(String(params.bidder)));
    const pathInternal = '/api/bidders/json-schemas/{bidder}'.replaceAll('{bidder}', () => encodeURIComponent(String(params.bidder)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getJsonSchema.paramsOrder = [{ type: 'parameters' }];
export const getServerSideBidders = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/bidders/server-side';
    const pathInternal = '/api/bidders/server-side';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getServerSideBidders.paramsOrder = [];
export const getSizes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/sizes';
    const pathInternal = '/api/sizes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filterPrefix : (params.filterPrefix ?? queryDefaults?.['filterPrefix']);
        if (value !== undefined) {
            urlParams.append('filterPrefix', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSizes.paramsOrder = [{ type: 'parameters' }];
export const getDefaultBidderConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/default-bidder-configs';
    const pathInternal = '/api/default-bidder-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDefaultBidderConfigs.paramsOrder = [{ type: 'parameters' }];
export const createDefaultBidderConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/default-bidder-configs';
    const pathInternal = '/api/default-bidder-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDefaultBidderConfig.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getDefaultBidderConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.defaultBidderConfigId === undefined) {
        throw new Error('Missing required parameter: defaultBidderConfigId');
    }
    const path = '/api/ws-header-tag/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    const pathInternal = '/api/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDefaultBidderConfig.paramsOrder = [{ type: 'parameters' }];
export const updateDefaultBidderConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.defaultBidderConfigId === undefined) {
        throw new Error('Missing required parameter: defaultBidderConfigId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    const pathInternal = '/api/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDefaultBidderConfig.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteDefaultBidderConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.defaultBidderConfigId === undefined) {
        throw new Error('Missing required parameter: defaultBidderConfigId');
    }
    const path = '/api/ws-header-tag/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    const pathInternal = '/api/default-bidder-configs/{defaultBidderConfigId}'.replaceAll('{defaultBidderConfigId}', () => encodeURIComponent(String(params.defaultBidderConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteDefaultBidderConfig.paramsOrder = [{ type: 'parameters' }];
export const getUserIdModules = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/user-id-modules';
    const pathInternal = '/api/user-id-modules';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserIdModules.paramsOrder = [];
export const getUserIdModuleConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/user-id-module-configs';
    const pathInternal = '/api/user-id-module-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.moduleCode : (params.moduleCode ?? queryDefaults?.['moduleCode']);
        if (value !== undefined) {
            urlParams.append('moduleCode', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserIdModuleConfigs.paramsOrder = [{ type: 'parameters' }];
export const createUserIdModuleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/user-id-module-configs';
    const pathInternal = '/api/user-id-module-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createUserIdModuleConfig.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const updateUserIdModuleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userIdModuleConfigId === undefined) {
        throw new Error('Missing required parameter: userIdModuleConfigId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/user-id-module-configs/{userIdModuleConfigId}'.replaceAll('{userIdModuleConfigId}', () => encodeURIComponent(String(params.userIdModuleConfigId)));
    const pathInternal = '/api/user-id-module-configs/{userIdModuleConfigId}'.replaceAll('{userIdModuleConfigId}', () => encodeURIComponent(String(params.userIdModuleConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateUserIdModuleConfig.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteUserIdModuleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userIdModuleConfigId === undefined) {
        throw new Error('Missing required parameter: userIdModuleConfigId');
    }
    const path = '/api/ws-header-tag/user-id-module-configs/{userIdModuleConfigId}'.replaceAll('{userIdModuleConfigId}', () => encodeURIComponent(String(params.userIdModuleConfigId)));
    const pathInternal = '/api/user-id-module-configs/{userIdModuleConfigId}'.replaceAll('{userIdModuleConfigId}', () => encodeURIComponent(String(params.userIdModuleConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteUserIdModuleConfig.paramsOrder = [{ type: 'parameters' }];
export const getCompanyUserIdModuleDefaults = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/company-user-id-module-defaults';
    const pathInternal = '/api/company-user-id-module-defaults';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyUserIdModuleDefaults.paramsOrder = [];
export const updateCompanyUserIdModuleDefaults = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/company-user-id-module-defaults';
    const pathInternal = '/api/company-user-id-module-defaults';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyUserIdModuleDefaults.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getSupportedPrebidBidders = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/ad-server/prebid-bidders';
    const pathInternal = '/api/ad-server/prebid-bidders';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSupportedPrebidBidders.paramsOrder = [];
export const createPrebidAdServerPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.bidder === undefined) {
        throw new Error('Missing required parameter: bidder');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/ad-server/header-tags/{headerTagId}/prebid-bidders/{bidder}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{bidder}', () => encodeURIComponent(String(params.bidder)));
    const pathInternal = '/api/ad-server/header-tags/{headerTagId}/prebid-bidders/{bidder}'
        .replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)))
        .replaceAll('{bidder}', () => encodeURIComponent(String(params.bidder)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPrebidAdServerPlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const createGoogleAdServerPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.headerTagId === undefined) {
        throw new Error('Missing required parameter: headerTagId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/ad-server/header-tags/{headerTagId}/google-bidder'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    const pathInternal = '/api/ad-server/header-tags/{headerTagId}/google-bidder'.replaceAll('{headerTagId}', () => encodeURIComponent(String(params.headerTagId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createGoogleAdServerPlacement.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const recreateGoogleAdServerPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.googleBidderConfigId === undefined) {
        throw new Error('Missing required parameter: googleBidderConfigId');
    }
    const path = '/api/ws-header-tag/ad-server/google-bidders/{googleBidderConfigId}/recreate'.replaceAll('{googleBidderConfigId}', () => encodeURIComponent(String(params.googleBidderConfigId)));
    const pathInternal = '/api/ad-server/google-bidders/{googleBidderConfigId}/recreate'.replaceAll('{googleBidderConfigId}', () => encodeURIComponent(String(params.googleBidderConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recreateGoogleAdServerPlacement.paramsOrder = [{ type: 'parameters' }];
/** Returns all active google bidder config ad unit path mappings with placement info */ export const getGoogleBidderConfigAdUnitMappings = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/google-bidder-configs/ad-unit-mappings';
    const pathInternal = '/api/google-bidder-configs/ad-unit-mappings';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getGoogleBidderConfigAdUnitMappings.paramsOrder = [];
/** returns list of placement ids */ export const getPlacementsByWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.websiteIds === undefined) {
        throw new Error('Missing required parameter: websiteIds');
    }
    const path = '/api/ws-header-tag/placements/filter-by-websites';
    const pathInternal = '/api/placements/filter-by-websites';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteIds !== undefined) {
        urlParams.append('websiteIds', params.websiteIds.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementsByWebsites.paramsOrder = [{ type: 'parameters' }];
/** List the floor experiments of the current company */ export const getFloorExperiments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-header-tag/floor-experiments';
    const pathInternal = '/api/floor-experiments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.headerTagId : (params.headerTagId ?? queryDefaults?.['headerTagId']);
        if (value !== undefined) {
            urlParams.append('headerTagId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFloorExperiments.paramsOrder = [{ type: 'parameters' }];
/** Create a floor experiment on one or more header tags of the current company */ export const createFloorExperiment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/floor-experiments';
    const pathInternal = '/api/floor-experiments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createFloorExperiment.paramsOrder = [{ type: 'body', paramName: 'form' }];
/**
 * Preview the first Step's floors and the end date proposed for the settings entered so far.
 * Writes nothing.
 */ export const previewFloorExperiment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-header-tag/floor-experiments/preview';
    const pathInternal = '/api/floor-experiments/preview';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
previewFloorExperiment.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Read one floor experiment back */ export const getFloorExperiment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.floorExperimentId === undefined) {
        throw new Error('Missing required parameter: floorExperimentId');
    }
    const path = '/api/ws-header-tag/floor-experiments/{floorExperimentId}'.replaceAll('{floorExperimentId}', () => encodeURIComponent(String(params.floorExperimentId)));
    const pathInternal = '/api/floor-experiments/{floorExperimentId}'.replaceAll('{floorExperimentId}', () => encodeURIComponent(String(params.floorExperimentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFloorExperiment.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
